module.exports = __webpack_public_path__ + "static/media/person.3c8f3b79.svg";